import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { makeDateForObjects } from "./../components/EverythingContext";
import ObjectLayout from "./../components/ObjectLayout";
import ObjectHeader from "./../components/ObjectHeader";
import ObjectConnections from "./../components/ObjectConnections";
import ViewChooser from "./../components/ViewChooser";

const PersonPage = ({ data, pageContext }) => {
  const { title, description, imageFile } = data.person;
  const { pdfs, images, timelineEntries, walks } = data;
  const allTheData = makeDateForObjects(pdfs.nodes, "pdfFile", "pdf")
    .concat(makeDateForObjects(images.nodes, "imageFile", "image"))
    .concat(makeDateForObjects(timelineEntries.nodes, "", "timelineEvent"));
  // console.log(data, pageContext.id);
  return (
    <ObjectLayout title={`Person: ${title}`}>
      <ObjectHeader title={title} />
      <p>{description}</p>
      {imageFile && imageFile.asset ? (
        <GatsbyImage image={imageFile.asset.gatsbyImageData} alt={title} />
      ) : null}
      <ViewChooser data={allTheData} />
      {pdfs.nodes.length ||
      images.nodes.length ||
      timelineEntries.nodes.lengh ||
      walks.nodes.length ? (
        <ObjectConnections
          pdfs={pdfs.nodes}
          images={images.nodes}
          timelineEntries={timelineEntries.nodes}
          walks={walks.nodes}
        />
      ) : null}
    </ObjectLayout>
  );
};

export default PersonPage;

export const pageQuery = graphql`
  query($id: String!) {
    person: sanityPerson(_id: { eq: $id }) {
      title
      description
      imageFile {
        asset {
          gatsbyImageData(width: 800)
        }
      }
    }
    pdfs: allSanityObjectPdf(
      filter: { people: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
        date
        dateApproximateness
        endDate
        endDateApproximateness
      }
    }
    images: allSanityObjectImage(
      filter: { people: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
        date
        dateApproximateness
        endDate
        endDateApproximateness
      }
    }
    timelineEntries: allSanityTimelineEntry(
      filter: { people: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
        date: startDate
        dateApproximateness
        endDate
        endDateApproximateness
      }
    }
    walks: allSanityWalk(
      filter: { people: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
      }
    }
  }
`;
